import { MlAllergenPrediction, MlAnalysisResponse } from "@/models/AllergenML/AllergenML";
import { NutrientSource } from "@/models/NutrientSource/NutrientSource";
import { formatCountrySpecificAllergenName } from "@/utils/AllergenDisplayNames";

export function getFlaggedIngredientCount(analysisResult: MlAnalysisResponse | null | undefined) {
  return analysisResult?.ingredients.filter((ingredient) => ingredient.allergens.length > 0).length ?? 0;
}

export function getAnalysisCountry(
  analysisResult: Pick<MlAnalysisResponse, "nutrientSource"> | null | undefined,
  fallbackCountry: NutrientSource
) {
  return analysisResult?.nutrientSource ?? fallbackCountry;
}

export function getCountryLabel(
  analysisResult: Pick<MlAnalysisResponse, "nutrientSource"> | null | undefined,
  fallbackCountry: NutrientSource
) {
  switch (getAnalysisCountry(analysisResult, fallbackCountry)) {
  case NutrientSource.Canada:
    return "Canada";
  case NutrientSource.UK:
    return "UK";
  case NutrientSource.US:
  default:
    return "USA";
  }
}

export function beautifyAllergenId(value: string) {
  return value
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/\bUs\b/g, "US");
}

export function formatAllergenName(value: string) {
  return (value || "").split("/")[0].trim();
}

export function isUkCerealsAllergen(
  allergenId: string,
  displayName: string,
  country: NutrientSource
) {
  if (country !== NutrientSource.UK) {
    return false;
  }

  const normalized = `${allergenId || ""} ${displayName || ""}`
    .toLowerCase()
    .replace(/[^a-z]/g, "");

  return normalized.indexOf("gluten") !== -1
    || normalized.indexOf("wheat") !== -1
    || normalized.indexOf("cerealscontaininggluten") !== -1;
}

export function getAllergenLabel(
  allergen: MlAllergenPrediction,
  analysisResult: Pick<MlAnalysisResponse, "nutrientSource"> | null | undefined,
  fallbackCountry: NutrientSource
) {
  const label = allergen.displayName || beautifyAllergenId(allergen.id);
  const country = getAnalysisCountry(analysisResult, fallbackCountry);

  if (isUkCerealsAllergen(allergen.id, label, country)) {
    return "Cereals";
  }

  return formatCountrySpecificAllergenName(formatAllergenName(label), country);
}